// 에디터 HTML 에 실제 내용이 있는지 — 태그·&nbsp;·폭 없는 공백·공백만이면 빈 값, img·audio 등 미디어 태그가 있으면 내용.
// 시험 미리보기의 읽기 지문 보충(ExamList.hasHtmlContent, docs/시험_관리_API.md 16절)과 같은 기준이고,
// 검색 응답의 선택지 보충(questionBankService)·시험 생성 마법사 미리보기도 이 판정을 쓴다. 관리자 화면과 같은 기준(2026-10-08).
// 기준을 바꿀 때는 관리자 화면팀·성취도 백엔드와 맞춘다.
export const hasHtmlContent = (html) => {
  if (!html) return false
  if (typeof html !== 'string') return !!html
  if (/<(img|video|audio|iframe|embed|object|svg)\b/i.test(html)) return true
  const text = html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;|&#160;|&#xA0;/gi, ' ')
    .replace(/[\u200B-\u200D\uFEFF]/g, '')
    .replace(/\s+/g, '')
  return text.length > 0
}
